import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import { saveWiki as saveWikiFromMonolith, WikiNamespaces, WikiObject } from '~/monolith-api';

const saveWikiSchema = z.object({
   namespace: z.custom<WikiNamespaces>(),
   title: z.string(),
   revisionid: z.number(),
   fields: z.object({
      major_approval_processid: z.number().nullable().optional(),
      minor_approval_processid: z.number().nullable().optional(),
      default_child_major_approval_processid: z.number().nullable().optional(),
      default_child_minor_approval_processid: z.number().nullable().optional(),
   }),
});

export default createBFFHandlers({
   post: async (req, res) => {
      const { namespace, title, revisionid, fields } = saveWikiSchema.parse(req.body);
      const monolithClient = getServerSideMonolithClient(req);
      const result = await saveWikiFromMonolith({
         namespace,
         title,
         revisionid,
         fields,
         common: {
            apiClient: monolithClient,
         },
      });
      res.status(200).json(result);
   },
});

export const saveWikiFromClient = async (
   namespace: WikiNamespaces,
   title: string,
   revisionid: number,
   fields: {
      major_approval_processid?: number | null;
      minor_approval_processid?: number | null;
      default_child_major_approval_processid?: number | null;
      default_child_minor_approval_processid?: number | null;
   }
): Promise<WikiObject> => {
   return bff()
      .post('/wikis/saveWiki', {
         namespace,
         title,
         revisionid,
         fields,
      })
      .then(response => response.data);
};
